import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { Location } from '@angular/common';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-manual-add-payroll',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent],
  templateUrl: './manual-add-payroll.component.html',
  styleUrls: ['./manual-add-payroll.component.css'],
})
export class ManualAddPayrollComponent implements OnInit {
  // ------------------ Properties ------------------
  payrollType: 'bank_transfer' | 'cash' | 'final' | null = null;
  bankTransferType: 'full' | 'partial' = 'full';
  user: any;

  // Amounts
  partialAmount = 0;
  remainingAmount = 0;
  compensationAmount = 0;
  taxAmount = 0;
  advanceAmount = 0;
  otherDeduction = 0;
  totalDeduction = 0;
  netSalary = 0;
  overtimeAmount = 0;
  extraOvertimeHours = 0;

  // Month & Year
  monthInt: number = new Date().getMonth() + 1;
  monthChar: string = new Date().toLocaleString('default', { month: 'long' });
  monthYear: number = new Date().getFullYear();

  isLoading = true;

  // Mapping for template display
  payrollTypeLabelMap: Record<string, string> = {
    bank_transfer: 'Bank Transfer',
    cash: 'Cash Payment',
    final: 'Final Settlement'
  };
  counts: any;
  current_released_salary: any;
  openSalary: any;
  public showSpinner = false;

  // ------------------ Constructor ------------------
  constructor(
    private router: Router,
    private dashboardService: DashboardService,
    private location: Location) { }

  // ------------------ Lifecycle ------------------
  ngOnInit(): void {
    setTimeout(() => (this.isLoading = false), 1500);

    // Get user from history state
    const now = new Date();
    this.user = history.state?.user;
    this.monthInt = history.state?.monthInt ?? (now.getMonth() + 1);
    this.monthChar = history.state?.monthChar ?? now.toLocaleString('en-US', { month: 'long' });
    this.monthYear = history.state?.monthYear ?? now.getFullYear();

    if (!this.user) {
      console.warn('No user data found!');
      return;
    }

    console.log('User Data:', this.user);
    this.fetchUserSalary(this.user?.id, this.monthInt, this.monthYear);
    this.getcounts(this.user?.id);

    //     if (this.user?.user_salary?.length > 0) {
    //       this.monthInt = this.user?.user_salary[0]?.month_int;
    //       this.monthChar = this.user?.user_salary[0]?.month_char;
    //       this.monthYear = this.user?.user_salary[0]?.month_year;
    //       this.taxAmount = this.user?.user_salary[0]?.tax || 0;
    //       this.advanceAmount = this.user.user_salary[0].advance_payment || 0;
    //       this.otherDeduction = this.user.user_salary[0].otherDeduction || 0;
    //       this.compensationAmount = this.user.user_salary[0].compensation_amount || 0;
    //       this.openSalary = this.user?.open_salary;
    // debugger
    //       this.payrollType = this.user.user_salary[0].payment_type;
    //       this.bankTransferType = this.user.user_salary[0].payment_status;
    //       this.remainingAmount = this.user.user_salary[0].remaining_amount;
    //       this.partialAmount = (this.user.user_salary[0].released_salary - this.remainingAmount);

    //       // Set payroll type based on salary payment_type
    //       const type = this.user.user_salary[0].payment_type;
    //       if (type === 'bank_transfer') this.payrollType = 'bank_transfer';
    //       else if (type === 'cash') this.payrollType = 'cash';
    //       else if (type === 'final') this.payrollType = 'final';



    //     }
    // this.calculateSalary();
    // this.updateRemaining();
  }

  // ------------------ Salary Calculation ------------------
  calculateSalary(): void {
    debugger
    const salary = this.user?.user_salary?.[0];
    if (!salary) {
      // If no salary record, we can still calculate expected net based on defaults
      const basicSalary = Number(this.user?.basic_salary || 0);
      const compensation = Number(this.compensationAmount || 0);
      this.totalDeduction = Number(this.taxAmount || 0) + Number(this.advanceAmount || 0) + Number(this.otherDeduction || 0) - compensation;
      this.current_released_salary = basicSalary - this.totalDeduction;
      this.updateRemaining();
      return;
    }

    // Sync advance payment to the object if needed (though we use this.advanceAmount for calculation)
    if (this.user.user_salary[0]) {
      this.user.user_salary[0].advance_payment = this.advanceAmount;
    }

    const basicSalary = Number(salary.basic_salary || 0);
    const overtime = Number(salary.overtime_amount || 0);
    const lateCheckIn = Number(salary.late_check_in_amount || 0);
    const shortHours = Number(salary.short_hours_amount || 0);
    const absents = Number(salary.absents_amount || 0);
    const unpaidLeaves = Number(salary.unpaid_leaves_amount || 0);
    const loan = Number(salary.loan_deduction_amount || 0);

    // Overtime Calculation
    debugger
    const systemOvertimeHours = Number(salary.overtime_hours || 0);
    const totalOvertimeHours = systemOvertimeHours + Number(this.extraOvertimeHours || 0);
    this.overtimeAmount = (basicSalary * 12 / 365 / 8) * totalOvertimeHours * 1.5;

    // Total Deduction = existing deduction + tax + advance + otherDeduction
    let systemDeduction = 0;

    if (this.openSalary === 1) {
      systemDeduction = 0;
    } else {
      systemDeduction =
        unpaidLeaves +
        absents +
        lateCheckIn +
        shortHours +
        Number(this.taxAmount || 0);

      if (loan > 0) {
        systemDeduction += loan;
      }
    }

    // 🔥 Add manual deductions (not handled in backend)
    this.totalDeduction =
      systemDeduction +
      Number(this.advanceAmount || 0) +
      Number(this.otherDeduction || 0) -
      Number(this.compensationAmount || 0);

    // Net Salary
    this.current_released_salary =
      basicSalary +
      this.overtimeAmount -
      this.totalDeduction;

    this.overtimeAmount = this.round(this.overtimeAmount);
    this.totalDeduction = this.round(this.totalDeduction);
    this.current_released_salary = this.round(this.current_released_salary);

    // Update remaining
    this.updateRemaining();
  }

  private round(value: any, decimals = 2): number {
    const numberValue = Number(value);
    if (isNaN(numberValue)) {
      return 0;
    }
    return Number(numberValue.toFixed(decimals));
  }

  updateRemaining(): void {
    debugger

    const basicSalary = Number(this.user?.user_salary?.[0]?.basic_salary || this.user?.basic_salary || 0);
    const overtime = Number(this.overtimeAmount || 0);  // Use calculated overtimeAmount, not stale backend value
    const deduction = Number(this.totalDeduction || 0);

    // Net salary calculated by backend logic + manual fields
    // Compensation is already subtracted from totalDeduction, so just subtract deduction
    const netSalary = this.round(basicSalary + overtime - deduction);

    // Remaining depends on bank transfer type
    if (this.bankTransferType === 'partial') {
      this.remainingAmount = this.round(netSalary - Number(this.partialAmount || 0));
    } else {
      this.remainingAmount = 0; // fully transferred
      this.partialAmount = netSalary; // optional: prefill full amount
    }
    this.current_released_salary = netSalary;

  }
  getTotalOvertimeHours(): number {
    const systemHours = Number(this.user?.user_salary?.[0]?.overtime_hours || 0);
    return systemHours + Number(this.extraOvertimeHours || 0);
  }

  onTransferTypeChange(): void {
    if (this.bankTransferType === 'full') {
      this.partialAmount = 0;   // reset input
    }

    this.updateRemaining();     // recalculate
  }
  // ------------------ Get Label for Template ------------------
  getSelectedPayrollLabel(): string {
    switch (this.payrollType) {
      case 'bank_transfer': return 'Bank Transfer';
      case 'cash': return 'Cash Payment';
      case 'final': return 'Final Settlement';
      default: return '-';
    }
  }

  // ------------------ Navigation ------------------
  paidLeavesnav(): void { this.router.navigate(['/show-leaves']); }
  attendanceReq(): void { this.router.navigate(['/user-attendance-list']); }
  loanReq(): void { this.router.navigate(['/loan-report']); }
  absentReq(): void { this.router.navigate(['/attendance-management']); }

  // ------------------ Salary Operations ------------------
  generateSalary(): void {
    // this.isLoading = true;
    debugger
    if (!this.user?.id) {
      Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: 'Error',
          text: 'User not selected!.',
          confirmButtonText: 'Ok',
          timer: 3000,
        });
      return;
    }
    this.showSpinner = true;

    const payload = {
      user_id: this.user.id,
      month_int: this.monthInt,
      month_char: this.monthChar,
      month_year: this.monthYear,
    };

    this.dashboardService.userGenerateSalary(
      payload.month_int,
      payload.month_char,
      payload.month_year,
      payload.user_id,

    ).then((res: any) => {
      // this.isLoading = false;
      this.showSpinner = false;


      const salary = res.data;

      // Update the user object so template reflects new salary
      if (salary) {
        this.user.user_salary = [salary];  // <-- Important: wrap in array
        this.monthInt = salary.month_int;
        this.monthChar = salary.month_char;
        this.monthYear = salary.month_year;


        // Update payroll type based on salary
        const type = salary.payment_type;
        if (type === 'bank_transfer') this.payrollType = 'bank_transfer';
        else if (type === 'cash') this.payrollType = 'cash';
        else if (type === 'final') this.payrollType = 'final';

        // Update payroll properties from generated salary
        this.taxAmount = (salary.tax !== null && salary.tax !== undefined) ? Number(salary.tax) : this.taxAmount;
        this.advanceAmount = (salary.advance_payment !== null && salary.advance_payment !== undefined) ? Number(salary.advance_payment) : this.advanceAmount;
        this.otherDeduction = (salary.other_deduction !== null && salary.other_deduction !== undefined) ? Number(salary.other_deduction) : this.otherDeduction;
        this.compensationAmount = (salary.compensation_amount !== null && salary.compensation_amount !== undefined) ? Number(salary.compensation_amount) : this.compensationAmount;

        // Recalculate amounts
        this.calculateSalary();
        this.updateRemaining();
      }


      // this.isLoading = false;
   
      if (res.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: res.message,
          text: res.success ? '' : 'Please check the user profile or try again.',
          showConfirmButton: !res.success,
          confirmButtonText: 'Ok',
          timer: res.success ? 2000 : undefined,
        });
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: res.message,
          text: res.success ? '' : 'Please check the user profile or try again.',
          showConfirmButton: !res.success,
          confirmButtonText: 'Ok',
          timer: res.success ? 2000 : undefined,
        });
      }



    });
  }

  saveSalary(status: 'draft' | 'approved'): void {
    if (!this.user?.id) {
     Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: 'Error',
          text:'Please check Something went Wrong.',
          showConfirmButton: false,
          confirmButtonText: 'Ok',
          timer: 2000
        });
      return;
    }

    this.showSpinner = true;
    // this.isLoading = true;

    const salary = this.user.user_salary?.[0] || {};

    this.payrollType

    const payload = {
      user_id: this.user.id,
      month_int: this.monthInt,
      month_char: this.monthChar,
      month_year: this.monthYear,
      basic_salary: salary.basic_salary || 0,
      overtime_hours: this.getTotalOvertimeHours(), // Send combined total
      overtime_amount: this.overtimeAmount,         // Send combined amount
      late_check_in_amount: salary.late_check_in_amount || 0,
      late_check_in: salary.late_check_in || 0,
      short_hours_amount: salary.short_hours_amount || 0,
      short_hours: salary.short_hours || 0,
      absents_amount: salary.absents_amount || 0,
      absents: salary.absents || 0,
      unpaid_leaves_amount: salary.unpaid_leaves_amount || 0,
      unpaid_leaves: salary.unpaid_leaves || 0,
      loan_deduction_amount: salary.loan_deduction_amount || 0,
      advance_payment: this.advanceAmount || 0,
      other_deduction: this.otherDeduction || 0,
      compensation_amount: this.compensationAmount || 0,
      tax: this.taxAmount || 0,
      total_deduction: this.totalDeduction || 0,
      released_salary: Math.round(this.current_released_salary || 0),
      status: status,
      payment_type: this.payrollType || 'bank_transfer',
      payment_status: this.bankTransferType,      // <-- Add payroll/payment type
      remaining_amount: this.remainingAmount,
      extra_overtime_hours: this.extraOvertimeHours,
      is_generated: true
    };


    this.dashboardService.updateUserSalary(payload).then((res: any) => {
      // this.isLoading = false;
      this.showSpinner = false;
      if (res.success && res.data) {
        const updatedSalary = res.data;

        // Ensure user_salary array exists
        if (this.user.user_salary?.length > 0) {
          this.user.user_salary[0] = updatedSalary;
        } else {
          this.user.user_salary = [updatedSalary];
        }

        // Update all component properties from backend response
        this.monthInt = updatedSalary.month_int;
        this.monthChar = updatedSalary.month_char;
        this.monthYear = updatedSalary.month_year;

        this.taxAmount = Number(updatedSalary.tax || 0);
        this.advanceAmount = Number(updatedSalary.advance_payment || 0);
        this.otherDeduction = Number(updatedSalary.other_deduction || 0);
        this.compensationAmount = Number(updatedSalary.compensation_amount || 0);
        this.openSalary = this.user?.open_salary || 0;

        this.payrollType = updatedSalary.payment_type as 'bank_transfer' | 'cash' | 'final';
        this.bankTransferType = updatedSalary.payment_status || 'full';
        this.remainingAmount = this.round(updatedSalary.remaining_amount || 0);
        this.partialAmount = this.round(Number(updatedSalary.released_salary || 0) - this.remainingAmount);

        // Recalculate totals using the updated salary data
        this.calculateSalary();
        this.updateRemaining();
      }

       if (res.success == true) {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: res.message,
          text: res.success ? '' : 'Please check the user profile or try again.',
          showConfirmButton: !res.success,
          confirmButtonText: 'Ok',
          timer: res.success ? 2000 : undefined,
        });
      } else {
        Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: res.message,
          text: res.success ? '' : 'Please check the input data or try again.',
          showConfirmButton: !res.success,
          confirmButtonText: 'Ok',
          timer: res.success ? 2000 : undefined,
        });
      }

    });
  }


  goBack() {
    this.location.back();
  }


  getcounts(user_id: any) {
    const id = user_id
    this.dashboardService.getCounts(id, this.monthInt, this.monthYear).then((res: any) => {
      this.counts = res.data
    });
  }

  fetchUserSalary(userId: number, month_int: any, month_Year: any) {
    this.dashboardService.getUserSalary(userId, month_int, month_Year).then((res: any) => {

      this.isLoading = false;
      if (res.success && res.data) {
        this.user = res.data;
        this.openSalary = this.user?.open_salary;

        if (this.user.user_salary?.length > 0) {
          const salary = this.user.user_salary[0];

          this.taxAmount = (salary.tax !== null && salary.tax !== undefined)
            ? Number(salary.tax)
            : Number(this.user.monthly_tax_amount || 0);

          this.advanceAmount = (salary.advance_payment !== null && salary.advance_payment !== undefined)
            ? Number(salary.advance_payment)
            : 0;

          this.otherDeduction = (salary.other_deduction !== null && salary.other_deduction !== undefined)
            ? Number(salary.other_deduction)
            : 0;

          this.compensationAmount = (salary.compensation_amount !== null && salary.compensation_amount !== undefined)
            ? Number(salary.compensation_amount)
            : 0;

          this.payrollType = salary.payment_type as 'bank_transfer' | 'cash' | 'final';
          this.bankTransferType = salary.payment_status || 'full';
          this.remainingAmount = this.round(salary.remaining_amount || 0);
          this.partialAmount = this.round((salary.released_salary || 0) - this.remainingAmount);

          this.monthInt = salary.month_int;
          this.monthChar = salary.month_char;
          this.monthYear = salary.month_year;

          this.calculateSalary();
          this.updateRemaining();
        } else {
          // Defaults when no salary record is found for the month
          this.taxAmount = Number(this.user.monthly_tax_amount || 0);
          this.advanceAmount = 0;
          this.otherDeduction = 0;
          this.compensationAmount = 0;
          this.payrollType = 'bank_transfer';
          this.bankTransferType = 'full';
          this.remainingAmount = 0;
          this.partialAmount = 0;

          // We still want to calculate totals even if only tax is set
          this.calculateSalary();
        }
      }
    }).catch(err => {
      this.isLoading = false;
      console.error(err);
      Swal.fire({
          iconHtml:
            ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: 'Error',
          text: 'Failed to fetch user salary.',
          showConfirmButton: false,
          confirmButtonText: 'Ok',
          timer: 2000 ,
        });
    });
  }

}
